import script from "./status-bar-cloud-license-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./status-bar-cloud-license-info.vue?vue&type=script&lang=ts&setup=true"

import "./status-bar-cloud-license-info.vue?vue&type=style&index=0&id=11375a61&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11375a61"]])

export default __exports__
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QResizeObserver,QTooltip});
